import { number } from 'yup'
import { safify } from '../utils/safify'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

export const instagramExternalIntegrationId = number()
  .default(undefined)
  .meta({ integrationType: ExternalIntegrationEnum.Instagram, autoFill: false, hideManualSectionPreview: true })
  .transform(safify)

export const twitterExternalIntegrationId = number()
  .default(undefined)
  .meta({ integrationType: ExternalIntegrationEnum.X, autoFill: false, hideManualSectionPreview: true })
  .transform(safify)

export const facebookExternalIntegrationId = number()
  .default(undefined)
  .meta({ integrationType: ExternalIntegrationEnum.Facebook, autoFill: false, hideManualSectionPreview: true })
  .transform(safify)

export const linkedInExternalIntegrationId = number()
  .default(undefined)
  .meta({ integrationType: ExternalIntegrationEnum.LinkedIn, autoFill: false, hideManualSectionPreview: true })
  .transform(safify)

export const wordpressExternalIntegrationId = number()
  .default(undefined)
  .meta({ integrationType: ExternalIntegrationEnum.WordPress, autoFill: false, hideManualSectionPreview: true })
  .transform(safify)

export const goHighLevelExternalIntegrationId = number()
  .default(undefined)
  .meta({ integrationType: ExternalIntegrationEnum.GoHighLevel, autoFill: false, hideManualSectionPreview: true })
  .transform(safify)

// Generic blog integration field that can handle multiple blog providers
export const blogExternalIntegrationId = number()
  .default(undefined)
  .meta({
    integrationType: ExternalIntegrationEnum.WordPress, // Default to WordPress for backward compatibility
    autoFill: false,
    hideManualSectionPreview: true,
    // Allow multiple blog providers - this will be handled by the ExternalIntegrationField component
    supportedProviders: [ExternalIntegrationEnum.WordPress, ExternalIntegrationEnum.GoHighLevel],
  })
  .transform(safify)
